import { render, staticRenderFns } from "./approveHeader.vue?vue&type=template&id=7296eb1a&scoped=true"
import script from "./approveHeader.vue?vue&type=script&lang=js"
export * from "./approveHeader.vue?vue&type=script&lang=js"
import style0 from "./approveHeader.vue?vue&type=style&index=0&id=7296eb1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7296eb1a",
  null
  
)

export default component.exports